import React, { useState } from 'react'
import { useAsyncDebounce } from "react-table";

import { SearchIcon } from '@heroicons/react/outline'

const GlobalFilter = ({ filter, setFilter }) => {
    const [value, setValue] = useState(filter);

    const onChange = useAsyncDebounce(value => {
        setFilter(value || undefined)
    }, 300)
    return (
        <div className='relative w-full overflow-hidden bg-white my-5 shadow-table '>
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 z-2 w-5 h-5 text-gray-400" />
            <input value={value || ''} onChange={(e) => {
                setValue(e.target.value);
                onChange(e.target.value);
            }}
                placeholder='Pretraži...'
                className='w-full pl-10  pr-4 py-3 placeholder:text-gray-400 text-gray-700 font-medium text-sm rounded  border border-transparent focus-within:border-bluePrimary
                transition' />
        </div>
    )
}

export default GlobalFilter
